import { Button, Typography } from '@mui/material';

import { OAuthProvider } from '@/enums/socialAuth';
import { handleError } from '@/utils/errorUtils';

import { Facebook } from '@/shared/icons/Facebook';
import { Google } from '@/shared/icons/Google';
import { SoundCloudLogoCloudMark } from '@/shared/icons/soundCloud/SoundCloudLogoCloudMark';

import { useStyles } from './SocialButton.styles';
import type { TSocialButtonProps } from './types';

const getIcon = (provider: OAuthProvider) => {
  switch (provider) {
    case OAuthProvider.google:
      return <Google />;

    case OAuthProvider.facebook:
      return <Facebook />;

    case OAuthProvider.soundCloud:
      return <SoundCloudLogoCloudMark width={50} height={23} />;

    default:
      handleError('SocialButton: Unknown OAuth provider requested');

      return null;
  }
};

export const SocialButton = ({ provider, children, ...props }: TSocialButtonProps) => (
  <Button classes={useStyles()} variant="outlined" {...props}>
    {getIcon(provider)}

    <Typography variant="body2">{children}</Typography>
  </Button>
);
